import { memo } from 'react';

export const closureAcceptCookies = (setOpen, setCookie, key) => () => {
  setOpen(false);
  setCookie(key, 1);
};

export const renderOnce = Component => memo(Component, () => true);
